import cn from 'classnames';
import { Fragment, ReactElement } from 'react';
import { FontIcon, Skeleton } from '@intigral/shared';
import { IProgramWithoutPoster, ProgramWithoutPoster } from './ProgramWithoutPoster';
import styles from './program.module.sass';

interface IProgramCard extends IProgramWithoutPoster {
    /**
     * Play/Details etc. buttons shown over the poster
     */
    CTAs?: ReactElement[];
    /**
     * If true, adds a blur effect to the background of the `Play` CTA button
     */
    withBlur?: boolean;
}

export const Program = ({ program, CTAs = [], withBlur, variant = 'panel', ...props }: IProgramCard) => {
    if (program.isLoading) {
        return (
            <>
                <div className={cn(styles.poster, { [styles.card]: variant === 'card' })}>
                    <Skeleton absolute />
                </div>
                <ProgramWithoutPoster program={program} variant={variant} />
            </>
        );
    }
    const { isReminderSet, addReminderButton, badge, poster, name, text, progress } = program;
    const drawerCTAs = props.drawerCTAs || [];
    const ctaElements = CTAs.map((cta, index) => <Fragment key={`program-cta-${index}`}>{cta}</Fragment>);
    // Figma "Cards3.0/Continue Watching": bar on the poster
    const barOnPoster = variant === 'card' && props.showProgress;

    return (
        <>
            <div
                className={cn(styles.poster, {
                    [styles.card]: variant === 'card',
                    [styles['with-cta-buttons']]: CTAs.length > 0,
                    [styles['with-drawer']]: drawerCTAs?.length > 0,
                })}
            >
                {/* `addReminderButton`'s appearance changes depending on whether reminder is set or not so, there's
                    no need for additional reminder indicator */}
                {isReminderSet && !addReminderButton && (
                    <FontIcon name="bell-filled" size="smaller" md="smaller" className={styles['reminder-icon']} />
                )}
                {badge ? badge : null}
                <div className={styles.img}>
                    <img src={poster} alt={name || text} />
                </div>
                <div className={CTAs.length > 1 ? styles['cta-bottom'] : styles.cta}>
                    {withBlur ? <div className={styles['with-blur']}>{ctaElements}</div> : ctaElements}
                </div>
                {barOnPoster && (
                    <span className={styles.progress}>
                        <i style={{ width: `${progress || 0}%` }} />
                    </span>
                )}
            </div>
            <ProgramWithoutPoster program={program} variant={variant} {...props} />
        </>
    );
};
